import React, { Component, Fragment } from 'react';
import { Table,Image } from "semantic-ui-react";
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea,Breadcrumb,Input} from "semantic-ui-react"
import DayPickerInput from "react-day-picker/DayPickerInput"
import shop from "shop/shop"
import {Row, Col, FormField, FormInput} from "elemental-react16"
import _ from "lodash"
import productStore from "stores/productStore"
import ordinals from "theme/arnoldsports/sortParamsVariant"
import moment                               from "moment"
import Spinner                              from "components/Spinner/Spinner"
import SuccessTable                         from "components/Product/SuccessTableReturn"
import { Redirect } from "react-router"
import { Link, withRouter } from "react-router-dom"
import Responsive from "react-responsive"
import { observer } from "mobx-react"
import DeliveryDatePicker from "components/Date/DeliveryDatePicker"

@withRouter
@observer
class ReturnAdminPage extends Component {
    state = {
        inventory: false,
        inventoryOrder: [],
        byId: {},
        loading: false,
        showContact: false,
        loadingDelivery: false,
        notFoundPositions: [],
        adminInterface: false, 
        customers: [],
        customerSearch: [],
        saved: false,
        searchString: "",
        searchResult: [],
        modalOpen: false,
        modalOpenSingle: false,
        idToDelete: "",
        newSeason: {
            season: {
                start: "",
                end: "",
                name: ""
            }
        },
    };

    componentDidMount() {
        if(!shop.session){
            console.log("!shop.session")
            this.props.history.push("/login")
          }
        if(!shop.session.handuser || shop.session.handId ){
            this.setState({adminInterface: true})
            this.handleFetchDate();
            this.handleLoadCustomers();
        }
        //this.handleLoadInventory();
        //this.handleLoadDelivery();
    }

    handleFetchDate = () => {
      console.log("DATA handleFetchDate")
      try {
        const response = shop.fetch('/shop/rest/config/?set=' + encodeURIComponent(JSON.stringify(["web.kv.saison","web.kv.start","web.kv.end"])), {
          method: 'GET',
          credentials: 'include'
        });
        console.log("DATA: ", response);
        response.then(data => {
          this.setState({
            newSeason: {
              season: {
          start: data["web.kv.start"],
          end: data["web.kv.end"],
          name: data["web.kv.saison"]
              }
            }
          });
        });
        console.log("DATA POST: ", this.state.newSeason);
        this.setState({saved: true});
      } catch (error) {
        console.error('Error fetching date:', error);
      }
    }


    handleLoadCustomers = async () => {
        console.log("handleLoadCustomers")
        try {
            let start = 0;
            let count = 200;
            let inventory = [];
            let response = null;
            this.setState({ loading: true });
            do {
                response = await shop.fetch(`/shop/rest/data/inventories?start=${start}&count=${count}`, {
                    method: "GET",
                    credentials: "include",
                });
                inventory = inventory.concat(response);
                start += count;
            } while (response.length === count);
            // process the loaded inventory data
            console.log("WHOLE INVENTORY PRE: ",inventory[0].values);
            //inventory[0].values = inventory[0].values.filter(item => item.extras['ts-ordertype-02'] === 'inventoryPackages');
            //console.log("WHOLE INVENTORY POST: ",inventory[0].values);
            this.setState({ customers: inventory[0].values, loading: false });
            this.setState({customerSearch: this.state.customers})
        } catch (error) {
            console.error(error);
        }
    }

    render() {
        let { size, customerId, customers, loadingRestore, loading,saved, searchResult, customerSearch, modalOpen, modalOpenSingle,idToDelete } = this.state
        const useMore = size > customers.length
        //console.log("CUSTOMERS: ", customers, customerSearch)

        if(!shop.session){
            console.log("!shop.session")
            this.props.history.push("/login")
            document.location.reload()
            return null
        }
        let { product, categoryId = "" } = this.props

        const handleChange = (event) => {
          //console.log("CHANGE: ", event.target)
          let tempname = event.target.name
          let tempname2 = event.target.className
          let tempvalue = event.target.value
          this.setState(prevState => {
            let newSeason = { ...prevState.newSeason };  
            newSeason[tempname][tempname2] = tempvalue;       
            return { newSeason }; 
            })
          };  

        const handleDateChangeStart = (date, name) => {
          console.log("DATE: ", date, name);
          let deliverdate = moment(date);
          if (deliverdate.isValid()) {
            deliverdate = deliverdate.format("DD.MM.YYYY");
            this.setState((prevState) => {
              let newSeason = { ...prevState.newSeason };
              newSeason.season["start"] = deliverdate;
              return { newSeason };
            });
          }
        };

        const handleDateChangeEnd = (date, name) => {
          console.log("DATE: ", date, name);
          let deliverdate = moment(date);
          if (deliverdate.isValid()) {
            deliverdate = deliverdate.format("DD.MM.YYYY");
            this.setState((prevState) => {
              let newSeason = { ...prevState.newSeason };
              newSeason.season["end"] = deliverdate;
              return { newSeason };
            });
          }
        };
        
        const handleSave = () => {
          const { start, end, name } = this.state.newSeason.season;
          if (start === "" || end === "" || name === "") {
            shop.toast("Bitte alle Felder ausfüllen");
            return;
          }
          const startDate = moment(start, "DD.MM.YYYY");
          const endDate = moment(end, "DD.MM.YYYY");
          if (!startDate.isValid() || !endDate.isValid()) {
            shop.toast("Falsches Datumsformat. Bitte verwenden Sie TT.MM.JJJJ.");
            return;
          }
          if (startDate.isAfter(endDate)) {
            shop.toast("Das Startdatum muss vor dem Enddatum liegen.");
            return;
          }
          
          //shop.fetch POST etc.
          
          shop.toast( "Ihre Saison wurde erfolgreich gespeichert." )
          console.log("SAVE", this.state.newSeason)
          shop.fetch('/shop/rest/config/', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              "web.kv.saison": this.state.newSeason.season.name,
              "web.kv.start": this.state.newSeason.season.start,
              "web.kv.end": this.state.newSeason.season.end
            })
          })
          .then(response => response.json())
          .then(data => {
            console.log('Success:', data);
          })
          .catch((error) => {
            console.error('Error:', error);
          });
          this.setState({saved: true})
        }
      
        const formatDate = date => {
          return moment( date ).format( "DD. MMMM YYYY" )
        }

        const handleDeleteInventory = async () => {
            console.log("DELETE INVENTORY: ", this.state.idToDelete.customer.id)
            try {
                await shop.fetch(`/shop/rest/data/inventories/${this.state.idToDelete.customer.id}`, {
                    method: "DELETE",
                    credentials: "include",
                });
                shop.toast("Kunde wurde zurückgesetzt, die Inventuren werden neu geladen.");
                this.setState( { modalOpenSingle: false} ) 
                this.handleLoadCustomers();
            } catch (error) {
                console.error(error);
            }
        }

        const handleDeleteInventoryCheck = ( id ) => {
          console.log("DELETE INVENTORY CHECK");
          this.setState( {
            modalOpenSingle: true} )
          this.setState( { idToDelete: id} )
      }

        const handleDeleteWholeInventory = async () => {
          console.log("DELETE WHOLE INVENTORY");
          try {
            for (let customer of this.state.customers) {
              console.log("DELETE WHOLE INVENTORY: ", customer);
              await shop.fetch(`/shop/rest/data/inventories/${customer.id}`, {
                method: "DELETE",
                credentials: "include",
              });
            }
            shop.toast("Alle Kunden wurden zurückgesetzt, die Inventuren werden neu geladen.");
            this.setState( { modalOpen: false} ) 
            this.handleLoadCustomers();
          } catch (error) {
            console.error(error);
          }
        };

        const handleCreatePDF = (id) => {
          console.log("GENERATE PDF", shop.config.API, id.customer);
          shop.toast("Ihre PDF wird generiert.");
          
            fetch(`${shop.config.API}reports/create?template=PaketBarcodes`, {
              method: "POST",
              credentials: "include",
              body: JSON.stringify({
                customer: id.customer.customerid,
                count: id.customer.extras.kartons_all,
              })
            })
            .then(response => {
              response.json().then(data => {
                console.log("RESPONSE DATA: ", data);
                const rid = data.rid;
                fetch(`${shop.config.API}reports/load/pakete.pdf?rid=${rid}`, {
                  method: "GET",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/pdf"
                  }
                })
                .then(responsePDF => responsePDF.blob())
                .then(blob => {
                  console.log("BLOB: ", blob);
                  const url = URL.createObjectURL(blob);
                  console.log("URL: ", url);
                  window.open(url, "_blank");
                })
                .catch(error => {
                  shop.toast("Fehler beim anzeigen der PDF.");
                  // Handle the error
                });
              }).catch(error => {
                shop.toast("Fehler beim Verarbeiten der Antwort.");
                // Handle the error
              });
            })
            .catch(error => {
              shop.toast("Fehler beim generieren der PDF.");
              // Handle the error
            });
      }

        const handleChangeSearchString = (event) => {
          //console.log("SEARCH CHANGE: ", event.target)
          this.setState({customerSearch: []})
          for(let i = 0; i < this.state.customers.length; i++){
            //console.log("SEARCH CHANGE: ", this.state.customers[i].customer.title)
            if(this.state.customers[i].customer.title.toUpperCase().includes(event.target.value.toUpperCase()) || this.state.customers[i].customer.map_id.includes(event.target.value) || this.state.customers[i].customer.street.toUpperCase().includes(event.target.value.toUpperCase()) || this.state.customers[i].customer.pcode.includes(event.target.value) || this.state.customers[i].customer.city.toUpperCase().includes(event.target.value.toUpperCase()) || this.state.customers[i].customer.country.toUpperCase().includes(event.target.value.toUpperCase())){
              //console.log("SEARCH CHANGE CORRECT: ", this.state.customers[i])
                this.setState(prevState => ({
                  customerSearch: [...prevState.customerSearch, this.state.customers[i]]
                }));
              }
              /*if(this.state.customers[i].article_nr.includes(event.target.value) || this.state.products[i].desc.short_des.toUpperCase().includes(event.target.value.toUpperCase()) || this.state.products[i].barcode.includes(event.target.value)){
                  this.setState(prevState => ({
                      productSearch: [...prevState.customerSearch, this.state.customers[i]]
                  }));
                  //console.log("RETURN SEARCH CHANGE CORRECT", this.state.products[i])
              }*/
          }
          //console.log("SEARCH CHANGE: ", this.state.customerSearch)
          this.setState({searchString: event.target.value})
        }; 

        const handleClearSearchString = () => {
          this.setState({customerSearch: customers, searchString: ""});
      }

        const MIN_DELAY = 0

        return (
            <Fragment>
                <Modal
                  closeIcon={<Icon name="close" />}
                  open={modalOpenSingle}
                  onClose={() => {
                    this.setState( { modalOpenSingle: false} )
                  }}
                  size="tiny"
                >
                  <Modal.Header>{translate( "Zurücksetzung der Inventur" )}</Modal.Header>
                  <Modal.Content>
                    <div className="f4 fw5 pb3 pt2">Sie sind im Begriff diese Inventur zu löschen, möchten Sie fortfahren?</div>
                    <table>
                      <colgroup>
                        <col width="70%"/>
                        <col width="30%"/>
                      </colgroup>
                      <tbody>
                        <tr className="bt bb b--black-20">
                          <td className="pt3 pb3">
                            <Button onClick={handleDeleteInventory}
                              primary >Inventur löschen</Button>
                          </td>
                          <td className="tr">
                            <Button onClick={() => {
                              this.setState( { modalOpenSingle: false} )
                            }}>Abbrechen</Button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Modal.Content>
                </Modal>
                <Modal className="pl3 pr3"
                            closeIcon={<Icon name="close" />}
                            open={modalOpen}
                            onClose={() => {
                              this.setState( {
                                modalOpen: false} )
                            }}
                            size="tiny"
                          >
                            <Modal.Header>{translate( "Zurücksetzung der Inventuren" )}</Modal.Header>
                            <Modal.Content className="pl3">
                            <div className="f4 fw5 pb3 pt2">Sie sind im Begriff alle {customers.length} Inventuren aller Kunden zu löschen, möchten Sie fortfahren?</div>
                              <table>
                                <colgroup>
                                  <col width="70%"/>
                                  <col width="30%"/>
                                </colgroup>
                                <tbody>
                                  <tr className="bt bb b--black-20">
                                    <td className="pt3 pb3">
                                      <Button primary onClick={handleDeleteWholeInventory}>Alle Inventuren löschen</Button>
                                    </td>
                                    <td className="tr">
                                      <Button onClick={() => {
                                        this.setState( {
                                          modalOpen: false} )
                                      }}>Abbrechen</Button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                            </Modal.Content>
                </Modal>
                <Responsive minWidth={790} >
                <section className="container pb4 pt4" >
                <div className="fr pa1"><Button primary className="mt4" onClick={() => this.props.history.push("/logout")}><Icon name={"power off"}/>Abmelden</Button></div>
                    <div className="pa4 bg-silver">
                        <div className="w-100">
                        <div className="db pv3 mb-2">
                        </div>
                        <h1>{translate("Saisoneingabe")}</h1>
                        <div className="pb2">
                        Geben Sie hier den Start und das Ende der Saison ein.
                        </div>
                        <Form>
                        <Form.Group >
                        <Form.Input width={10} label={translate("Saisonname")}><input fluid value={this.state.newSeason.season.name} onChange={handleChange} className="name" name="season" label="Saisonname:" placeholder={translate("Saisonname")}  /></Form.Input>
                        
                          <Form.Input label={translate("Saisonstart")}>
                          <DayPickerInput
                          className="bb b--black-20  datepicker"
                          value={this.state.newSeason.season.start}
                          placeholder={translate("Ihr Terminwunsch")}
                          formatDate={formatDate}
                          dayPickerProps={{
                            initialMonth: moment().add( MIN_DELAY, "day" ).toDate(),
                            disabledDays: [
                              {
                                before: moment().add( MIN_DELAY, "day" ).toDate()
                              }
                            ]
                          }}
                          onDayChange={handleDateChangeStart}/>
                            </Form.Input>
                          <Form.Input  label={translate("Saisonende")}>
                          <DayPickerInput
                          className="bb b--black-20"
                          value={this.state.newSeason.season.end}
                          placeholder={translate("Ihr Terminwunsch")}
                          formatDate={formatDate}
                          dayPickerProps={{
                            initialMonth: moment().add( MIN_DELAY, "day" ).toDate(),
                            disabledDays: [
                              {
                                before: moment().add( MIN_DELAY, "day" ).toDate()
                              }
                            ]
                          }}
                          onDayChange={handleDateChangeEnd}/>
                            </Form.Input>
                            <Form.Button style={{marginTop: "23px"}} primary
                            onClick={() => {
                              console.log("SAVE")
                              handleSave()}
                            }
                            >{translate("Speichern")}</Form.Button>
                          </Form.Group>
                        </Form>
                        <h3>{translate("Saisonübersicht")}</h3>
                        <Table className="pb3">
                            <colgroup>
                              <col width="60%"/>
                              <col width="20%"/>
                              <col width="20%"/>
                            </colgroup>
                          <Table.Header>
                            <Table.Row>
                              <Table.HeaderCell>{translate("Saisonname")}</Table.HeaderCell>
                              <Table.HeaderCell className="tl">{translate("Saisonstart")}</Table.HeaderCell>
                              <Table.HeaderCell>{translate("Saisonende")}</Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>
                          <Table.Body>
                          {saved && <Table.Row>
                              <Table.Cell>{this.state.newSeason.season.name}</Table.Cell>
                              <Table.Cell>{this.state.newSeason.season.start}</Table.Cell>
                              <Table.Cell>{this.state.newSeason.season.end}</Table.Cell>
                            </Table.Row>}
                          </Table.Body>
                        </Table>
                        <h1>{translate( "Retouren" )}</h1>
                        <div className="pb2">
                        In folgender Tabelle schalten Sie Kunden für die erneute Retoureneingabe frei.
                        </div>
                        {/*<div className="pv2">
                            <AccountSearch loading={loading} onChange={this.handleResult}/>
                        </div>*/}
                        <div className="headerInline" >
                          <FormInput
                            Icon="search"
                            style={{ width: "75%" }}
                            className={""}
                            value={this.state.searchString}
                            onChange={handleChangeSearchString} icon="search" placeholder={translate( "Suche nach GLN / ILN, Name oder Adresse" ) + " ..."}>
                          </FormInput>
                          <Button onClick={handleClearSearchString} style={{backgroundColor: "#ffffff", maxWidth:"55px"}} >
                          <Icon name="close"></Icon>
                          </Button><div className="pr2"></div>
                          <Button primary onClick={() => this.setState({ modalOpen: true })} >
                            Inventuren Zurücksetzen
                          </Button>
                        </div>
                        {loading && <div className="pa4 tc">
                            <Spinner size="md" type="inverted"/>
                        </div>}
                        {/*<pre>{JSON.stringify( customers, null, 2 )}</pre>*/}
                        {!loading && <div className="pa3 bg-white cf cb">
                            {<TableAccounts onDelete={handleDeleteInventory} onDeleteCheck={handleDeleteInventoryCheck} onCreate={handleCreatePDF} modalOpen={modalOpenSingle} customers={customerSearch} to={shop.locationAfterLogin || this.props.to || "/home"}/>}
                            {/*<TableAccounts onSelect={this.handleSelect} customers={customers} to={this.props.to || "/home"}/>*/}
                            {customerSearch.length === 0 && <div className="pa3 tl">{translate( "keine Kunden gefunden" )}</div>}

                            {useMore && <div className="pv3 tc"><Button loading={loading} onClick={this.loadMore}>{translate( "mehr" )}</Button></div>}
                            <div className="fl">
                            <Button as={Link} to={"/logout"} basic size="small">{translate( "back" )}</Button>

                            </div>
                        </div>}
                        </div>
                    </div>
                </section>
                </Responsive>
                <Responsive maxWidth={789} >
                <section>
                    <div className="pa4 bg-silver">
                        <div className="w-100">
                        <div className="db pv3 mb-2">
                        </div>
                        <h1>{translate("Saisoneingabe")}</h1>
                        <div className="pb2">
                        Geben Sie hier den Start und das Ende der Saison ein.
                        </div>
                        <Form className="pb3 bb b--black-10">
                        <Form.Input label={translate("Saisonname")}><input fluid value={this.state.newSeason.season.name} onChange={handleChange} className="name" name="season" label="Saisonname:" placeholder={translate("Saisonname")}  /></Form.Input>
                        </Form>
                        <Form className="pb3 bb b--black-10">
                        <Form.Group  >
                          <Form.Input label={translate("Saisonstart")}>
                          <DayPickerInput
                          className="bb b--black-20  datepicker"
                          value={this.state.newSeason.season.start}
                          placeholder={translate("Ihr Terminwunsch")}
                          formatDate={formatDate}
                          dayPickerProps={{
                            initialMonth: moment().add( MIN_DELAY, "day" ).toDate(),
                            disabledDays: [
                              {
                                before: moment().add( MIN_DELAY, "day" ).toDate()
                              }
                            ]
                          }}
                          onDayChange={handleDateChangeStart}/>
                            </Form.Input>
                          <Form.Input  label={translate("Saisonende")}>
                          <DayPickerInput
                          className="bb b--black-20"
                          value={this.state.newSeason.season.end}
                          placeholder={translate("Ihr Terminwunsch")}
                          formatDate={formatDate}
                          dayPickerProps={{
                            initialMonth: moment().add( MIN_DELAY, "day" ).toDate(),
                            disabledDays: [
                              {
                                before: moment().add( MIN_DELAY, "day" ).toDate()
                              }
                            ]
                          }}
                          onDayChange={handleDateChangeEnd}/>
                            </Form.Input>
                            <Form.Button style={{marginTop: "18px"}} className="pt2" primary
                            onClick={() => {
                              console.log("SAVE")
                              handleSave()}
                            }
                            >{translate("Speichern")}</Form.Button>
                          </Form.Group>
                        </Form>
                        <h3 className="pt3">{translate("Saisonübersicht")}</h3>

                        <table className="pr3 pl3 pb3">
                            <colgroup>
                                <col width="25%" />
                                <col width="75%" />
                            </colgroup>
                                <tbody>
                                    <tr className="bb b--black-20">
                                        <td>
                                            <div>
                                                <p className="fw7">Saisonname:</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <p className="tr">{this.state.newSeason.season.name}</p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="bb b--black-20">
                                        <td>
                                            <div >
                                                <p className="fw7">Saisonstart:</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <p className="tr">{this.state.newSeason.season.start}</p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="bb b--black-20">
                                        <td>
                                            <div>
                                                <p className="fw7">Saisonende:</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <p className="tr">{this.state.newSeason.season.end}</p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        <h1 className="pt3">{translate( "Retouren" )}</h1>
                        <div className="pb2">
                        In folgender Tabelle schalten Sie Kunden für die erneute Retoureneingabe frei.
                        </div>
                        {/*<div className="pv2">
                            <AccountSearch loading={loading} onChange={this.handleResult}/>
                        </div> */}
                                                <div className="headerInline" >
                          <FormInput
                            Icon="search"
                            style={{ width: "75%" }}
                            className={""}
                            value={this.state.searchString}
                            onChange={handleChangeSearchString} icon="search" placeholder={translate( "Suche nach GLN / ILN, Name oder Adresse" ) + " ..."}>
                          </FormInput>
                          <Button onClick={handleClearSearchString} style={{backgroundColor: "#ffffff", maxWidth:"55px"}} >
                          <Icon name="close"></Icon>
                          </Button><div className="pr2"></div>
                          
                        </div>
                        <div className="pt2 pb2">
                        <Button primary onClick={() => this.setState({ modalOpen: true })} >
                            Inventuren Zurücksetzen
                          </Button>
                          <Modal className="pl3 pr3"
                            closeIcon={<Icon name="close" />}
                            open={modalOpen}
                            onClose={() => {
                              this.setState( {
                                modalOpen: false} )
                            }}
                            size="tiny"
                          >
                            <Modal.Header>{translate( "Zurücksetzung der Inventuren" )}</Modal.Header>
                            <Modal.Content className="pl3">
                            <div className="f4 fw5 pb3 pt2">Sie sind im Begriff alle {customers.length} Inventuren aller Kunden zu löschen, möchten Sie fortfahren?</div>
                              <table>
                                <colgroup>
                                  <col width="70%"/>
                                  <col width="30%"/>
                                </colgroup>
                                <tbody>
                                  <tr className="bt bb b--black-20">
                                    <td className="pt3 pb3">
                                      <Button primary onClick={handleDeleteWholeInventory}>Alle Inventuren löschen</Button>
                                    </td>
                                    <td className="tr">
                                      <Button onClick={() => {
                                        this.setState( {
                                          modalOpen: false} )
                                      }}>Abbrechen</Button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                            </Modal.Content>
                            </Modal>
                        </div>
                        {loading && <div className="pa4 tc">
                            <Spinner size="md" type="inverted"/>
                        </div>}
                        {/*<pre>{JSON.stringify( customers, null, 2 )}</pre>*/}
                        {!loading && <div className="pa3 bg-white cf cb">
                            {<TableAccounts onDelete={handleDeleteInventory} onDeleteCheck={handleDeleteInventoryCheck} onCreate={handleCreatePDF} customers={customerSearch} to={shop.locationAfterLogin || this.props.to || "/home"}/>}
                            {/*<TableAccounts onSelect={this.handleSelect} customers={customers} to={this.props.to || "/home"}/>*/}
                            {customerSearch.length === 0 && <div className="pa3 tl">{translate( "keine Kunden gefunden" )}</div>}

                            {useMore && <div className="pv3 tc"><Button loading={loading} onClick={this.loadMore}>{translate( "mehr" )}</Button></div>}
                            <div className="fl pt2">
                            <Button as={Link} to={"/logout"} basic size="small">{translate( "back" )}</Button>

                            </div>
                        </div>}
                        </div>
                    </div>
					</section>

                </Responsive>
            </Fragment>
        );
    }
}


class AccountSearch extends Component {

    state = {
      value  : "",
      error  : false,
      loading: false
    }
  
    search( value, page = 1, count = 24 ) {
      this.setState( { loading: true } )
      let start = (page - 1) * count
      console.log( "SEARCH", value )
      let modifiedValue = value
      if(shop.config.USE_OLD_SEARCH){
        modifiedValue = `%${value}%`
      }
      shop.fetch( `/shop/rest/data/customers/search?title=${encodeURIComponent( `%${modifiedValue}%` )}&count=${count}&start=${start}` ) // pre-urlencoded % = %25
        .then( data => {
          console.log( { data } )
          const { size, result } = data
          this.props.onChange && this.props.onChange( { size, customers: result, query: value } )
          this.setState( { loading: false } )
        } )
        .catch( error => {
          this.setState( { error } )
          shop.toast( translate( "toast.SESSION_CLOSED" ) )
          console.error( "Error fetching customers", error )
        } )
    }
  
    reset = () => {
      this.props.onChange && this.props.onChange( { size: false, customers: [] } )
      this.setState( { value: "" } )
    }
  
    handleChange = e => {
      let value = e.target.value
      this.setState( { value } )
      this.search( value )
      /*if ( value && value.length >= 3 ) {
        this.search( value )
      } else {
        this.props.onChange && this.props.onChange( { size: false, customers: [] } )
      }*/
    }
  
    render() {
      const { value, loading, error } = this.state
  
      return (
        <div className="AccountSearch">
          <Input className="w-50 mr2" value={value} icon="search" loading={loading} placeholder={translate("Kunde, PLZ oder Name..")} onChange={this.handleChange}/>
          <Button className="dib " style={{align: "right"}} onClick={this.reset} basic icon={"close"}/>
          {error && <Redirect to={"/login/"}/>}
        </div>
      )
    }
  }
  
  
  const TableAccounts = ( { to, onDelete, onDeleteCheck, onCreate, customers, modalOpen } ) => (
    <Fragment>
      <Responsive minWidth={790} >
      <Table compact>
        {/*console.log("CUSTOMERS TABLE ACCOUNTS: ", customers)*/}
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>GLN / ILN</Table.HeaderCell>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Adresse</Table.HeaderCell>
            <Table.HeaderCell>{translate( "Registriert" )}</Table.HeaderCell>
            <Table.HeaderCell>{translate( "Pakete" )}</Table.HeaderCell>
            <Table.HeaderCell>Aktionen</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {customers.map( customer => {
              return (
                <Table.Row key={customer.map_id}>
                  {/*console.log("CUSTOMER: ", customer.register)*/}
                  <Table.Cell>{customer.customerid}</Table.Cell>
                  <Table.Cell>{customer.customer.title}</Table.Cell>
                  <Table.Cell>{customer.customer.street}<br/>{customer.customer.pcode}&nbsp;{customer.customer.city}<br/>{customer.customer.country}</Table.Cell>
                  <Table.Cell>{moment(customer.register).format('DD.MM.YYYY')}</Table.Cell>
                  <Table.Cell>{customer.extras.kartons_all === null || customer.extras.kartons_all === "null," || customer.extras.kartons_all === "null" ? "" : customer.extras.kartons_all}</Table.Cell>
                  <Table.Cell>
                  <tr><td className="pb2"><Button style={{minWidth:"150px"}} onClick={() => {
                    onDeleteCheck( { customer } )
                  }} size={"tiny"} primary>{translate( "Zurücksetzen " )}</Button></td></tr>
                    {/*<tr><td className="pb2"><Button style={{minWidth:"150px"}} onClick={() => {
                    onCreate( { customer } )
                  }} size={"tiny"} primary>{translate( "PDF erzeugen" )}</Button></td></tr>*/}
                  </Table.Cell>
                </Table.Row>
              )
            
          } )}

        </Table.Body>

      </Table>
      </Responsive>
      <Responsive maxWidth={789} >
        {/*console.log("CUSTOMERS TABLE ACCOUNTS: ", customers)*/}
          {customers.map( customer => {
              return (
                  <table key={customer.map_id}>
                    <colgroup>
                      <col width="50%"/>
                      <col width="50%"/>
                    </colgroup>
                    <tbody>
                    <tr className="pb2 pt2">
                      <td className="pb2 bb">GLN / ILN</td>
                      <td className="pb2 tr bb b">{customer.customerid}</td>
                    </tr>
                    <tr className="">
                      <td className="pb2 bb">Name</td>
                      <td className="pb2 tr bb b">{customer.customer.title}</td>
                    </tr>
                    <tr className="">
                      <td className="pb2 bb">Adresse</td>
                      <td className="pb2 tr bb b">{customer.customer.street}<br/>{customer.customer.pcode}&nbsp;{customer.customer.city}<br/>{customer.customer.country}</td>
                    </tr>
                    <tr className="">
                      <td className="pb2 bb">Registriert</td>
                      <td className="pb2 tr bb b">{moment(customer.register).format('DD.MM.YYYY')}</td>
                    </tr>
                    <tr className="">
                      <td className="pb2 bb">Pakete</td>
                      <td className="pb2 tr bb b">{customer.extras.kartons_all === null || customer.extras.kartons_all === "null," || customer.extras.kartons_all === "null" ? "" : customer.extras.kartons_all}</td>
                    </tr>
                    <tr className="">
                      <td className="pb2 bb bw3">Aktionen</td>
                      <td className="pb2 tr bb b bw3">
                        <Button style={{minWidth:"150px"}} onClick={() => {
                          onDeleteCheck( { customer } )
                        }} size={"tiny"} primary>{translate( "Zurücksetzen " )}</Button>
                        
                        {/*<div className="pb2"></div>
                        <Button style={{minWidth:"150px"}} onClick={() => {
                          onCreate( { customer } )
                        }} size={"tiny"} primary>{translate( "PDF erzeugen" )}</Button>*/}
                      </td>
                    </tr>
                    </tbody>
                  </table>
              )
            
          } )}</Responsive>
    </Fragment>
  )

export default ReturnAdminPage;


// WEBPACK FOOTER //
// ./src/pages/returnCheckout/ReturnAdminPage.js